import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx } from "vue"

import { ElDrawer } from 'element-plus'
import { ref, computed, unref, reactive, watch } from 'vue'
import { NodeTypeEnum } from '../enums'
import { FlowFormModel, PropertyEvent } from '../types'
import process from './process.vue'
import start from './start.vue'
import custom from './custom.vue'
import decision from './decision.vue'
import end from './end.vue'
import fork from './fork.vue'
import join from './join.vue'
import task from './task.vue'
import transition from './transition.vue'
import subProcess from './subProcess.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  extendAttrConfig: { // 扩展属性配置
    type: Object
  },
  allUser: {
    type: Array as any,
    default: () => []
  },
  deptList: {
    type: Array as any,
    default: () => []
  },
  roleList: {
    type: Array as any,
    default: () => []
  },
  posList: {
    type: Array as any,
    default: () => {
      return []
    }
  }
},
  emits: ['change'],
  setup(__props, { expose: __expose, emit: __emit }) {

const NODE_NAME_LIST = [
  'snaker:custom', 'snaker:decision',
  'snaker:end', 'snaker:fork', 'snaker:join', 'snaker:start',
  'snaker:task'] as string[]
// 组件列表
const COMPONENT_LIST = {
  process,
  start,
  custom,
  decision,
  end,
  fork,
  join,
  task,
  transition,
  subProcess
}
// 事件
const emits = __emit
// 属性
const props = __props
const drawer = ref(false)
const drawerRef = ref(null)
const formData = reactive({} as FlowFormModel)
// 标题
const title = computed(() => {
  if (formData.type === 'process') {
    return '设置流程属性'
  } else if (formData.type === 'snaker:transition') {
    return '设置边属性'
  } else if (NODE_NAME_LIST.includes(formData.type)) {
    return '设置节点属性'
  } else if (formData.type === 'snaker:subProcess') {
    return '设置子流程属性'
  }
  return ''
})
// 组件类型
const componentType = computed(() => {
  const mFormData = unref(formData)
  if (!mFormData || !mFormData.type) return
  return COMPONENT_LIST[mFormData.type.replace('snaker:', '')]
})
// 节点名称
const nodeName = computed((): NodeTypeEnum => {
  const mFormData = unref(formData)
  if (!mFormData || !mFormData.type) return NodeTypeEnum.ignore
  return mFormData.type.replace('snaker:', '') as unknown as NodeTypeEnum
})
// 处理emits
const handleEmits = (propertyName:string, propertyValue: any) => {
  if (propertyValue === undefined) return
  emits('change', {
    type: unref(nodeName),
    propertyName: propertyName,
    propertyValue: propertyValue
  } as PropertyEvent)
}
// 表单属性keys
const propertyKeys = [
  // 流程属性
  'name', 'displayName', 'expireTime', 'instanceUrl', 'instanceNoClass',
  // 开始节点和结束节点属性
  'name', 'preInterceptors', 'postInterceptors',
  // 自定义节点属性
  'name', 'displayName', 'clazz', 'methodName', 'args', 'preInterceptors', 'postInterceptors',
  // 决策节点属性
  'name', 'expr', 'handleClass', 'preInterceptors', 'postInterceptors',
  // 任务节点属性
  'form', 'assignee', 'assignmentHandler', 'taskType', 'performType', 'reminderTime', 'reminderRepeat', 'expireTime',
  'autoExecute', 'callback', 'width', 'height', 'field', 'userTypeId', 'userPartId'
] as string []
// 去重后的key
const propertyKeysSet = Array.from(new Set(propertyKeys))
propertyKeysSet.forEach((key: string) => {
  // 监听属性变化
  watch(() => formData[key], (n) => handleEmits(key, n), { deep: true })
})
// 显示抽屉
const show = (args: FlowFormModel) => {
  // 将args的值复制给formData
  const width = args.width ? args.width : (args.type === 'snaker:subProcess' ? 500 : 120)
  const height = args.height ? args.height : (args.type === 'snaker:subProcess' ? 300 : 80)
  Object.assign(formData, args, { width: Number(width), height: Number(height) })
  console.log('start---formData', formData)
  if (formData.field) {
    formData.field = JSON.parse(formData.field)
  }
  if (!formData.userTypeId) {
    formData.userTypeId = '1'
  }
  drawer.value = true
}
// 抽屉关闭处理
const handleClose = () => {
  // 清空表单值
  Object.keys(formData).forEach((key: string) => {
    delete formData[key]
  })
}
// 导入属性及方法给外部调用
__expose({
  show
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDrawer), {
    "destroy-on-close": "",
    direction: "rtl",
    "append-to-body": "",
    title: title.value,
    ref_key: "drawerRef",
    ref: drawerRef,
    onClose: handleClose,
    modelValue: drawer.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event))
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(componentType.value), {
        modelValue: formData,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData) = $event)),
        allUser: props.allUser,
        extendAttrConfig: props.extendAttrConfig || {},
        deptList: props.deptList,
        roleList: props.roleList,
        posList: props.posList
      }, null, 8, ["modelValue", "allUser", "extendAttrConfig", "deptList", "roleList", "posList"]))
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})